var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-dark p-4"},[_c('div',{staticClass:"nav hvh-flex column"},_vm._l((Object.keys(_vm.tabs)),function(key,index){return _c('p',{key:index,staticClass:"button"},[_c('button',{class:{ 'active-tab': key === _vm.value },on:{"click":function($event){return _vm.$emit('input', key)}}},[_vm._v(_vm._s(_vm.tabs[key].name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }